import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const ManagementUserIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M15.9286 6.75V6C15.9286 5.46563 15.8107 4.95938 15.5996 4.5H15.5357C14.529 4.5 13.6353 4.05 13.0607 3.35156C12.3879 4.48594 11.1062 5.25 9.64286 5.25H8.15C8.10089 5.49375 8.07143 5.74219 8.07143 6V6.75C8.07143 8.82188 9.82946 10.5 12 10.5C14.1705 10.5 15.9286 8.82188 15.9286 6.75ZM12 0C15.4719 0 18.2857 2.68594 18.2857 6V6.75C18.2857 10.0641 15.4719 12.75 12 12.75C8.52812 12.75 5.71429 10.0641 5.71429 6.75V6C5.71429 2.68594 8.52812 0 12 0ZM13.5125 19.6125L15.6634 15.5062C15.8107 15.225 16.125 15.0609 16.4442 15.1125C20.1714 15.7312 23 18.8297 23 22.5609C23 23.3578 22.3223 24 21.4924 24H2.50759C1.67768 24 1 23.3531 1 22.5609C1 18.8297 3.82857 15.7312 7.5558 15.1125C7.87991 15.0609 8.18929 15.225 8.33661 15.5062L10.4875 19.6125L11.2683 16.8375L10.3549 15.3844C10.0406 14.8828 10.4187 14.25 11.0277 14.25H12H12.9674C13.5763 14.25 13.9545 14.8875 13.6402 15.3844L12.7268 16.8375L13.5076 19.6125H13.5125ZM6.8192 17.6391C5.04152 18.3328 3.72054 19.8844 3.42098 21.75H8.97009L6.8192 17.6391ZM15.0299 21.75H20.579C20.2795 19.8844 18.9585 18.3328 17.1808 17.6391L15.0299 21.75Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default ManagementUserIcon
